<template>
  <Badge
    :value="getCompanyLabel(company)"
    :class="getCompanyBadgeClass(company)"
    class="px-3 py-1 rounded-full text-xs font-medium"
  />
</template>

<script setup lang="ts">
import Badge from 'primevue/badge'
import type { CompanyType } from '@/types/user'

defineProps<{
  company?: CompanyType
}>()

const getCompanyLabel = (company?: CompanyType): string => {
  const labelMap: Record<string, string> = {
    maxstationary: 'Max Stationary',
    ostnasik: 'OST Nasik',
    'shradhha-ent': 'Shradhha Ent',
  }
  return company ? labelMap[company] || company : 'No Company'
}

const getCompanyBadgeClass = (company?: CompanyType): string => {
  if (!company) return 'bg-gray-100 text-gray-800 border border-gray-200'

  const classMap: Record<string, string> = {
    maxstationary: 'bg-amber-100 text-amber-800 border border-amber-200',
    ostnasik: 'bg-teal-100 text-teal-800 border border-teal-200',
    'shradhha-ent': 'bg-indigo-100 text-indigo-800 border border-indigo-200',
  }
  return classMap[company] || 'bg-gray-100 text-gray-800 border border-gray-200'
}
</script>

<style scoped>
.bg-amber-100 { background-color: #fef3c7; }
.bg-teal-100 { background-color: #ccfbf1; }
.bg-indigo-100 { background-color: #e0e7ff; }
.text-amber-800 { color: #92400e; }
.text-teal-800 { color: #115e59; }
.text-indigo-800 { color: #3730a3; }
</style>
